import { render, staticRenderFns } from "./BasicDetailSeparator.vue?vue&type=template&id=afc6ae70&functional=true&"
import script from "./BasicDetailSeparator.vue?vue&type=script&lang=js&"
export * from "./BasicDetailSeparator.vue?vue&type=script&lang=js&"
import style0 from "./BasicDetailSeparator.vue?vue&type=style&index=0&id=afc6ae70&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports